import { useImage } from '@hooks/useImage';

const navigation_links_2 = [
  {
    label: 'Vitamins',
    path: `${process.env.GATSBY_VITL_HOST_NAME}/products/vitamins`,
  },
  {
    label: 'DNA',
    path: `${process.env.GATSBY_VITL_HOST_NAME}/product/dna`,
  },
  {
    label: 'Blood',
    path: `${process.env.GATSBY_VITL_HOST_NAME}/product/blood`,
  },
  {
    label: 'Register your kit',
    path: `${process.env.GATSBY_VITL_HOST_NAME}/kit`,
  },
  {
    label: 'Practitioners',
    path: `${process.env.GATSBY_VITL_HOST_NAME}/practitioners`,
  },
  {
    label: 'Student discount',
    path: `${process.env.GATSBY_VITL_HOST_NAME}/blog/article/student-discount`,
  },
];

const navigation_links = [
  {
    label: 'Science',
    path: `${process.env.GATSBY_VITL_HOST_NAME}/science`,
  },
  {
    label: 'My Vitl',
    path: `${process.env.GATSBY_VITL_HOST_NAME}/myvitl`,
  },
  {
    label: 'Contact us & FAQs',
    path: `${process.env.GATSBY_VITL_HOST_NAME}/contact`,
  },
  {
    label: 'Careers',
    path: `https://vitl.workable.com`,
  },
  {
    label: 'About us',
    path: `${process.env.GATSBY_VITL_HOST_NAME}/about`,
  },
];

const social_links = [
  {
    icon: 'facebook',
    url: 'https://www.facebook.com/vitlhealth',
  },
  {
    icon: 'instagram',
    url: 'https://www.instagram.com/vitlhealth',
  },
  {
    icon: 'twitter',
    url: 'https://twitter.com/VITLhealth',
  },
];

export const FOOTER_DATA = {
  logo: useImage(['logo_footer.svg']),
  navigation_links,
  navigation_links_2,
  social_links_label: 'Follow us',
  social_links,
};
